import { YARD_RECEIPT_MISSING_MESSAGES, type ReceiveTruckInput, type YardReceiptView } from '@chukua/common';

/** What the supervisor has in the two fields; null is a field left empty. */
export interface Readings {
  odometerKm: number | null;
  fuelLevelPercent: number | null;
}

/** The fields start from the check on the trip, the driver's or the yard's own. */
export function initialReadings(view: YardReceiptView): Readings {
  return { odometerKm: view.check?.odometerKm ?? null, fuelLevelPercent: view.check?.fuelLevelPercent ?? null };
}

/**
 * What would stop Receive with the readings as typed. Proof of delivery comes from the server, which alone knows it; the two readings are judged here so
 * the block clears as soon as the supervisor types them, with the same words the server's 409 uses.
 */
export function blockersFor(view: YardReceiptView, readings: Readings): string[] {
  if (view.verdict === 'refused' || view.verdict === 'received') return [];
  const blockers: string[] = [];
  if (view.missing.some((item) => item.code === 'proof_of_delivery')) blockers.push(YARD_RECEIPT_MISSING_MESSAGES.proof_of_delivery);
  if (readings.odometerKm === null) blockers.push(YARD_RECEIPT_MISSING_MESSAGES.odometer);
  if (readings.fuelLevelPercent === null) blockers.push(YARD_RECEIPT_MISSING_MESSAGES.fuel_level);
  return blockers;
}

/** The body for Receive: both readings, which the server treats as no change when they match the check already on the trip. */
export function toReceiveInput(readings: Readings): ReceiveTruckInput {
  return {
    ...(readings.odometerKm === null ? {} : { odometerKm: readings.odometerKm }),
    ...(readings.fuelLevelPercent === null ? {} : { fuelLevelPercent: readings.fuelLevelPercent }),
  };
}

/** "Truck KXX 123A received", adding the work orders the receipt raised. */
export function receivedToast(truckRegistration: string | null, workOrderCount: number): string {
  const truck = `Truck ${truckRegistration ?? 'unknown'} received`;
  if (workOrderCount === 0) return truck;
  return `${truck}, ${workOrderCount} ${workOrderCount === 1 ? 'work order' : 'work orders'} raised`;
}
